import { toast } from "react-toastify";
import { DynamicField, DynamicFieldTypes } from "src/components/dynamic-widget";
import DynamicFormWidget from "src/components/dynamic-widget/DynamicFormWidget";
import { DataService } from "src/services/data-service";
import { useState } from "react";
import GenericDrawer from "src/components/drawer/GenericDrawer";

interface IAddJobProps {
  onSuccess: () => void;
  onClose: () => void;
}

const AddJob: React.FC<IAddJobProps> = ({ onClose, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);

  const [formConfig, setFormConfig] = useState<Record<string, DynamicFieldTypes>>({
    Title: {
      type: DynamicField.TEXT,
      required: true,
      name: "Title",
      title: "Job Name",
      value: "",
      disabled: submitting,
    },
    Type: {
      type: DynamicField.TEXT,
      required: true,
      name: "Type",
      title: "Job Type",
      value: "",
      disabled: submitting,
    },
    Location: {
      type: DynamicField.TEXT,
      required: true,
      name: "Location",
      title: "Job Location",
      value: "",
      disabled: submitting,
    },
    Description: {
      type: DynamicField.TEXTAREA,
      required: true,
      name: "Description",
      title: "Job Description",
      value: "",
      disabled: submitting,
    },
  });

  const submit = async (data: Record<string, any>) => {
    setSubmitting(true);

    try {
      const response = await DataService.post("api/job/create", data);

      if (!response.ok) {
        const result: { message: string } = await response.json();
        throw new Error(result.message || "An error occurred!");
      }

      toast.success("Job added successfully!");
      await onSuccess();
      onClose();
      return true;
    } catch (error) {
      toast.error(error.message || "Failed to create job!");
      return false;
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <GenericDrawer title={"Add Job"} open={true} onClose={onClose}>
      <DynamicFormWidget
        drawerMode
        title=""
        fields={formConfig}
        onSubmit={submit}
      />
    </GenericDrawer>
  );
};

export default AddJob;
